import { render } from "./reviewVideoView.vue?vue&type=template&id=56e37912"
import script from "./reviewVideoView.vue?vue&type=script&lang=js"
export * from "./reviewVideoView.vue?vue&type=script&lang=js"

import "./reviewVideoView.vue?vue&type=style&index=0&id=56e37912&lang=css"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.17_vue@3.5.17_typescript@4.9.5__webpack@5.89.0_@swc+core@1.12.7_/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/reviewVideo/reviewVideoView.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "56e37912"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('56e37912', __exports__)) {
    api.reload('56e37912', __exports__)
  }
  
  module.hot.accept("./reviewVideoView.vue?vue&type=template&id=56e37912", () => {
    api.rerender('56e37912', render)
  })

}


export default __exports__